<template>
  <el-dialog
    :title="model.id > 0 ? '编辑分类' : '新建分类'"
    :visible.sync="visible"
    label-width="100px"
    width="600px"
    @close="$emit('update:show', false)"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      size="small"
      label-width="100px"
    >
      <el-form-item
        label="上级分类"
        label-width="100px"
        v-if="model.father_id > 0"
      >
        <el-input
          v-model="model.father_name"
          autocomplete="off"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item label="分类名称" label-width="100px" prop="name">
        <el-input v-model="model.name" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false" size="small">取 消</el-button>
      <el-button type="primary" @click="submitForm" size="small"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { createCCMCategory, updateCCMCategory } from '@/service/getData'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
    cates: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          {
            min: 1,
            max: 30,
            message: '长度在 1 到 30 个字符',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.model.id > 0) {
            let res = await updateCCMCategory(this.model)
            if (res.code == 0) {
              this.$emit('updated', res.data)
              this.visible = false
            }
          } else {
            let res = await createCCMCategory(this.model)
            if (res.code == 0) {
              this.$emit('created', res.data)
              this.visible = false
            }
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>